import React, { ReactNode } from "react";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { isRegistrationDomain } from "@utils/membership/membershipUtils";
import { WrappedLink } from "@components/navigation";
import { useAppContext } from "@state/hooks/shared";

export default function HeaderLogo() {
	return (
		<figure className="header--root__figure">
			<HeaderLogoRedirectWrapper>
				<img
					className="header--root__logo"
					src="/assets/images/logo-negative.svg"
					alt=""
				/>
			</HeaderLogoRedirectWrapper>
		</figure>
	);
}

function HeaderLogoRedirectWrapper(props: { children: ReactNode }) {
	const { culture } = useAppContext();

	if (isRegistrationDomain()) {
		return (
			<a
				href={`${WEBPACK_WEBSITE_URL}/${culture}/${DefaultPath.HOME}`}
				className="header--root__figure__link"
			>
				{props.children}
			</a>
		);
	}

	return (
		<WrappedLink
			to={`/${culture}/${DefaultPath.HOME}`}
			className="header--root__figure__link"
		>
			{props.children}
		</WrappedLink>
	);
}
